/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import EmptyViewerSourceCreator from '../empty/empty-viewer-source-creator';

/**
 * Typ média obrázek s podporou přehrávání pouze v online stavu.
 * Obrázek se při každém zobrazení načítá z URL v síti.
 * @implements {ViewerType}
 */
class PlaylistDeterministicViewerType {
  /**
   * Vytvoří instanci.
   * @param {PlaylistDeterministicViewerControllerFactory} controllerFactory
   */
  constructor(controllerFactory) {
    this.controllerFactory = controllerFactory;
    this.sourceCreator = new EmptyViewerSourceCreator();
  }

  /** @inheritdoc */
  createController() {
    return this.controllerFactory.create();
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Obrázky mají v detailu média nastavení "Kontrolovat aktuální verzi".
    // Hodnota se předává v parametrech média.
    return medium.params?.checkFile ?? false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(''));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    return false;
  }

  /** @inheritdoc */
  isSeekable(medium) {
    return true;
  }

  /** @inheritdoc */
  isStatic(medium) {
    return false;
  }
}

export default PlaylistDeterministicViewerType;
